import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const EmptyLessonsCount = () => (
  <section className="border-primary flex h-64 w-full items-center justify-center rounded-lg border">
    <div className="flex flex-col gap-y-2 text-center">
      <Typography.TitleSm weight="semibold">
        {t("courses.content")}
      </Typography.TitleSm>
      <Typography.LabelMd>{t("courses.no_published")}</Typography.LabelMd>
    </div>
  </section>
);
